function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48pt",
    height: "48pt",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(25.490196%,25.490196%,25.490196%)",
      fillOpacity: 1
    },
    d: "M 3.515625 47.515625 C 2.714844 47.515625 2.015625 47.214844 1.414062 46.613281 C 0.214844 45.414062 0.214844 43.515625 1.414062 42.414062 L 42.414062 1.414062 C 43.613281 0.214844 45.515625 0.214844 46.613281 1.414062 C 47.8125 2.613281 47.8125 4.515625 46.613281 5.613281 L 5.613281 46.613281 C 5.015625 47.214844 4.3125 47.515625 3.515625 47.515625 Z M 3.515625 47.515625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(25.490196%,25.490196%,25.490196%)",
      fillOpacity: 1
    },
    d: "M 44.414062 47.414062 C 43.613281 47.414062 42.914062 47.113281 42.3125 46.515625 L 1.414062 5.613281 C 0.214844 4.414062 0.214844 2.613281 1.414062 1.414062 C 2.613281 0.214844 4.515625 0.214844 5.613281 1.414062 L 46.515625 42.3125 C 47.714844 43.515625 47.714844 45.414062 46.515625 46.515625 C 45.914062 47.113281 45.214844 47.414062 44.414062 47.414062 Z M 44.414062 47.414062 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelblack);
export default __webpack_public_path__ + "static/media/cancel black.0a36a69f3dcb1c570ad332db59ad75c8.svg";
export { ForwardRef as ReactComponent };